"use strict";

var unitas = unitas || {};

const dropdownTitles = document.querySelectorAll(".js-filter-dropdown-title");
const countriesTab = document.getElementById(
  "js-filter-dropdown-tab-countries"
);
const citiesTab = document.getElementById("js-filter-dropdown-tab-cities");
const countriesContent = document.getElementById(
  "js-filter-dropdown-content-countries"
);
const citiesContent = document.getElementById(
  "js-filter-dropdown-content-cities"
);
const filterSortToggle = document.getElementById("js-filters-sort-toggle");
const filterSortList = document.getElementById("js-filters-sort-list");
const filterSortListItems = document.querySelectorAll(
  ".js-filter-sort-list-item"
);
const filterDropdownCheckboxes = document.querySelectorAll(
  ".js-filter-dropdown-checkbox p"
);

unitas.filters =
  unitas.filters ||
  (function() {
    function init() {
      if (dropdownTitles.length > 0) {
        document.addEventListener("keyup", function() {
          var input, filter, ul, li, label, i, txtValue;

          input = document.querySelector("#searchDestinations");
          if (input) {
            filter = input.value.toUpperCase();
            ul = document.querySelector("#destinationList");
            li = ul.querySelectorAll("li");

            for (i = 0; i < li.length; i++) {
              label = li[i].querySelectorAll("label")[0];
              txtValue = label.textContent || label.innerText;
              if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = "";
              } else {
                li[i].style.display = "none";
              }
            }
          }
        });

        for (let i = 0; i < dropdownTitles.length; i++) {
          const current = dropdownTitles[i];
          current.addEventListener("click", function(e) {
            const clickedTarget = e.currentTarget;
            const innerElement = clickedTarget.parentNode.querySelector(
              ".js-filter-dropdown-inner"
            );
            //Close open element
            if (
              !innerElement.classList.contains("filter-dropdown-inner--open")
            ) {
              const openElement = document.querySelector(
                ".filter-dropdown-inner--open"
              );

              if (openElement) {
                openElement.classList.remove("filter-dropdown-inner--open");
              }
            }

            if (innerElement) {
              innerElement.classList.toggle("filter-dropdown-inner--open");
            }
          });
        }
      }

      if (filterSortToggle && filterSortList && filterSortListItems) {
        filterSortToggle.addEventListener("click", function(e) {
          filterSortList.classList.toggle("filters-sort__list--open");
        });

        for (let i = 0; i < filterSortListItems.length; i++) {
          const current = filterSortListItems[i];
          current.addEventListener("click", function(e) {
            filterSortList.classList.toggle("filters-sort__list--open");
          });
        }
      }
    }

    function showCountries() {
      hideCities();
      countriesTab.classList.add("filter-dropdown-tabs__item--active");
      countriesContent.classList.add("filter-dropdown-content--active");
    }

    function showCities() {
      hideCountries();
      citiesTab.classList.add("filter-dropdown-tabs__item--active");
      citiesContent.classList.add("filter-dropdown-content--active");
    }

    function hideCountries() {
      countriesTab.classList.remove("filter-dropdown-tabs__item--active");
      countriesContent.classList.remove("filter-dropdown-content--active");
    }

    function hideCities() {
      citiesTab.classList.remove("filter-dropdown-tabs__item--active");
      citiesContent.classList.remove("filter-dropdown-content--active");
    }
    return {
      init: init,
      showCountries: showCountries,
      showCities: showCities,
    };
  })();
